import React from 'react'
import { FormControl, FormLabel } from '@mui/material'
import Input from 'src/components/Input'
import { useAppDispatch, useAppSelect } from 'src/hooks/useRedux'

import { setPayload } from '../../ducks/home.reducer'

const NationalInsuranceNo: React.FC = () => {
  const { payload } = useAppSelect((state) => state.home)
  const dispatch = useAppDispatch()

  const isRequired = !payload.cardSerialNumber

  return (
    <FormControl sx={{ width: '100%' }}>
      <FormLabel
        sx={{
          fontSize: (theme) => theme.typography.fontSize + 2,
          fontWeight: (theme) => theme.typography.fontWeightRegular,
        }}
      >
        National Insurance Number
      </FormLabel>
      <Input
        value={payload.nino}
        onChange={(e) =>
          dispatch(
            setPayload({
              ...payload,
              nino: `${e.target.value}`.trim(),
            }),
          )
        }
        placeholder="Enter national insurance number"
        required={isRequired}
      />
    </FormControl>
  )
}

export default NationalInsuranceNo
